import Pagenation from "components/Pagenation";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as dbmsApi from "../../apis/DbmsApi";
import { apiWrapper } from "apis/CommonApi";
import { getDateTime } from "utils/date";

//상태 Status 수신 로그
export default function StatusLogComponent() {
  const itemsPerPage = 100;
  const [searchText, setSearchText] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const [previous, setPrevious] = useState(null);
  const [next, setNext] = useState(null);
  const [page, setPage] = useState(1);

  useEffect(() => {
    getData(1);
  }, []);

  //page: 1베이스
  const getData = (page, url = null) => {
    apiWrapper(async () => {
      let result;
      if (url !== null) {
        result = await dbmsApi.getStatusReceiveLogListByUrl(url);
      } else {
        result = await dbmsApi.getStatusReceiveLogList(
          searchText,
          page,
          itemsPerPage
        );
      }

      const { status, data } = result;
      if (status === true) {
        setDataSource(data);

        setPrevious(data.previous);
        setNext(data.next);
        setPage(page);
      } else {
        alert(`${data}`);
      }
    });
  };

  const handleChangeSearchText = (e) => {
    setSearchText(e.target.value);
  }

  const handleSearch = (e) => {
    if (e.type === "click" || (e.type === "keydown" && e.keyCode === 13)) {
      getData(page);
    }
  }

  const handlePageArrowClick = (page, isNext) => {
    let url = null;
    if (isNext === false) {
      url = previous;
    } else {
      url = next;
    }

    getData(page, url);
  }

  return (
    <>
      <div class="viewBoard viewDBMSBoard overTableScroll">
        <div class="top_board pc">
          <p class="title_board">상태 Status 수신 로그</p>
          <div class="wrap_search openSearch">
            <div class="box_search">
              <div class="select_box">
                <button class="btn_select">
                  <p>화재수신기 일련번호</p>
                </button>
              </div>
              <input class="" type="text" placeholder="검색어를 입력해주세요." onChange={handleChangeSearchText} onKeyDown={handleSearch} defaultValue={searchText} />
              <button class="btn_search" onClick={handleSearch}>
                <i class="x-icon icon_search"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="top_board mb">
          <div class="wrap_logo">
            {/* <!-- <img src="" alt="" class="img_logo"> --> */}
          </div>
          <div class="header_dept">
            <p class="user">COWORKER</p>
            <div class="wrap_contr">
              <Link class="set_contr" to="">
                <img src="/images/my_btn_mb.png" alt="" />
              </Link>
            </div>
          </div>
        </div>
        <div class="top_board navi_board mb">
          <Link class="wrap_navi" to="/">
            <p class="title_navi">상태 Status 수신 로그</p>
          </Link>

          <div class="wrap_right mb">
            <Link class="btn_page_left" to="/dbmsMenu.html">
              <i class="x-icon"></i>
            </Link>
          </div>
        </div>

        <div class="table_board">
          <div class="wrap_table scroll_table">
            <div class="containerTable dbmsTable statusReceiverLogTable">
              <ul class="head_table">
                <li>
                  <p>관리 ID</p>
                </li>
                <li>
                  <p>화재수신기 모델명</p>
                </li>
                <li>
                  <p>펌웨어 버전</p>
                </li>
                <li>
                  <p>프로토콜버전</p>
                </li>
                <li>
                  <p>메세지 구분</p>
                </li>
                <li>
                  <p>발생일시</p>
                </li>
                <li>
                  <p>상태보고</p>
                </li>
                <li>
                  <p>보고 구분</p>
                </li>
                <li>
                  <p>보고 주기</p>
                </li>
                <li>
                  <p>통신모듈 전원</p>
                </li>
                <li>
                  <p>감지기동작 1구역</p>
                </li>
                <li>
                  <p>감지기동작 2구역</p>
                </li>
                <li>
                  <p>감지기동작 3구역</p>
                </li>
                <li>
                  <p>감지기동작 4구역</p>
                </li>
                <li>
                  <p>감지기동작 5구역</p>
                </li>
                <li>
                  <p>화재축적동작 1구역</p>
                </li>
                <li>
                  <p>화재축적동작 2구역</p>
                </li>
                <li>
                  <p>화재축적동작 3구역</p>
                </li>
                <li>
                  <p>화재축적동작 4구역</p>
                </li>
                <li>
                  <p>화재축적동작 5구역</p>
                </li>
                <li>
                  <p>발신기동작 1구역</p>
                </li>
                <li>
                  <p>발신기동작 2구역</p>
                </li>
                <li>
                  <p>발신기동작 3구역</p>
                </li>
                <li>
                  <p>발신기동작 4구역</p>
                </li>
                <li>
                  <p>발신기동작 5구역</p>
                </li>
                <li>
                  <p>주경종</p>
                </li>
                <li>
                  <p>지구경종</p>
                </li>
                <li>
                  <p>유도등</p>
                </li>
                <li>
                  <p>표시등</p>
                </li>
                <li>
                  <p>화재이보</p>
                </li>
                <li>
                  <p>교류전원</p>
                </li>
                <li>
                  <p>예비전원</p>
                </li>
                <li>
                  <p>배터리고장</p>
                </li>
                <li>
                  <p>회로고장 1번</p>
                </li>
                <li>
                  <p>회로고장 2번</p>
                </li>
                <li>
                  <p>회로고장 3번</p>
                </li>
                <li>
                  <p>회로고장 4번</p>
                </li>
                <li>
                  <p>회로고장 5번</p>
                </li>
                <li>
                  <p>축적 제어 SW</p>
                </li>
                <li>
                  <p>유도등 제어 SW</p>
                </li>
                <li>
                  <p>비상방송 제어 SW</p>
                </li>
                <li>
                  <p>화재이보 제어 SW</p>
                </li>
                <li>
                  <p>동작 시험 제어 SW</p>
                </li>
                <li>
                  <p>회로부저 제어 SW</p>
                </li>
                <li>
                  <p>주경종 제어 SW</p>
                </li>
                <li>
                  <p>지구경종 제어 SW</p>
                </li>
                <li>
                  <p>자동복구 제어 SW</p>
                </li>
                <li>
                  <p>화재복구 제어 SW</p>
                </li>
              </ul>

              <div class="body_table">
                <div class="inner_table_wrap">
                  {dataSource.results &&
                    dataSource.results.map((item, index) => (
                      <div class="wrap_table_item">
                        <div class="inner_table_item table_item_01">
                          <p class="cont_table_item">
                            {item.id}
                          </p>
                        </div>
                        <div class="inner_table_item table_item_01">
                          <p class="cont_table_item">
                            {item.fireReceiverModel}
                          </p>
                        </div>
                        <div class="inner_table_item table_item_01">
                          <p class="cont_table_item">
                            {item.firmwareVersion}
                          </p>
                        </div>
                        <div class="inner_table_item table_item_01">
                          <p class="cont_table_item">
                            {item.protocolVersion}
                          </p>
                        </div>
                        <div class="inner_table_item table_item_01">
                          <p class="cont_table_item">
                            {item.messageType}
                          </p>
                        </div>
                        <div class="inner_table_item table_item_01">
                          <p class="cont_table_item">
                            {getDateTime(new Date(item.eventTime))}
                          </p>
                        </div>
                        <div class="inner_table_item table_item_02">
                          <p class="cont_table_item">
                            {item.reportType}
                          </p>
                        </div>
                        <div class="inner_table_item table_item_03">
                          <p class="cont_table_item">
                            {item.reportCategory}
                          </p>
                        </div>
                        <div class="inner_table_item table_item_04">
                          <p class="cont_table_item">
                            {item.reportInterval}
                          </p>
                        </div>
                        {item.statusValues.map((value, index) => (
                          <div class="inner_table_item table_item_01">
                            <p class="cont_table_item">
                              {(() => {
                                if (value !== null) {
                                  if (item.statusValues.length > 34 && (index === 34 || index === 35 || index === 36)) {
                                    //회로부저/주경종/지구경종 제어 SW는 반대로 표시
                                    if (value === true) {
                                      return 'OFF';
                                    } else {
                                      return 'ON';
                                    }
                                  } else {
                                    if (value === true) {
                                      return 'ON';
                                    } else {
                                      return 'OFF';
                                    }
                                  }
                                } else {
                                  return '';
                                }
                              })()}
                            </p>
                          </div>
                        ))}
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="wrap_controll">
          <div id="pagination">
            <Pagenation
              totalItemsCount={dataSource.count}
              itemsPerPage={itemsPerPage}
              selectedPage={page}
              setPage={(value) => setPage(value)}
              handlePageArrowClick={handlePageArrowClick}
            />
          </div>
        </div>
      </div>
    </>
  );
}
